export const BRAND = {
  name: "Blue Velvet",
  legalName: "Blue Velvet Lifestyle Private Limited",
  tagline: "Transforming Jewelry Sourcing For You",
  domain: "bluevelvet.life",
};

const cleanNum = (n) => n.replace(/[^\d]/g, "");

export const CONTACT = {
  phones: [
    { label: "Marketing", number: "+91 73376 98777", raw: "917337698777" },
    { label: "Sales",     number: "+91 77954 26777", raw: "917795426777" },
    { label: "Office",    number: "+91 91135 00322", raw: "919113500322" },
  ],
  branches: ["Udupi", "Surat", "Bangalore"],
  email: "hello@bluevelvet.life",
  instagram: "https://www.instagram.com/bluevelvet_lifestyle?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
  instagramHandle: "@bluevelvet_lifestyle",
  linkedin: "https://linkedin.com/company/bluevelvet-life",
  addressLine1: "Blue Velvet Lifestyle Private Limited",
  addressLine2: "Udupi · Surat · Bangalore, India",
};

// Default WhatsApp routes to Marketing (primary point of contact)
export const DEFAULT_WA = CONTACT.phones[0];

export const INSTAGRAM_REELS = [
  { src: "https://customer-assets.emergentagent.com/job_velvet-sourcing/artifacts/pmssp4bp_WhatsApp%20Video%202026-05-06%20at%2011.14.57%20AM.mp4", caption: "Atelier showcase" },
  { src: "https://customer-assets.emergentagent.com/job_velvet-sourcing/artifacts/05sog9wr_WhatsApp%20Video%202026-05-06%20at%2011.15.11%20AM.mp4", caption: "New arrivals" },
  { src: "https://customer-assets.emergentagent.com/job_velvet-sourcing/artifacts/yvkafyky_WhatsApp%20Video%202026-05-06%20at%2011.15.48%20AM.mp4", caption: "Bridal collection" },
  { src: "https://customer-assets.emergentagent.com/job_velvet-sourcing/artifacts/1wjbdrcr_WhatsApp%20Video%202026-05-06%20at%2011.15.50%20AM.mp4", caption: "Diamond detail" },
  { src: "https://customer-assets.emergentagent.com/job_velvet-sourcing/artifacts/l9s3q13m_WhatsApp%20Video%202026-05-06%20at%2011.16.09%20AM.mp4", caption: "Heritage craft" },
];

export const waLink = (message = "Hello Blue Velvet, I'd like to know more about your B2B sourcing platform.", phone = DEFAULT_WA) => {
  return `https://wa.me/${cleanNum(phone.raw)}?text=${encodeURIComponent(message)}`;
};

export const waLinkFor = (label, message = "Hello Blue Velvet") => {
  const p = CONTACT.phones.find((x) => x.label.toLowerCase() === label.toLowerCase()) || DEFAULT_WA;
  return waLink(message, p);
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/retailers", label: "For Retailers" },
  { to: "/contact", label: "Contact" },
];

export const STATS = [
  { value: 5000, suffix: "+", label: "Orders Processed" },
  { value: 300, suffix: "+", label: "Jewelers Enabled" },
  { value: 5000, suffix: "+", label: "Designs Curated" },
  { value: 30, suffix: "+", label: "Years Expertise" },
  { value: 45, suffix: "yr", label: "Group Legacy" },
];

export const TESTIMONIALS = [
  {
    quote: "Blue Velvet transformed our sourcing. We now compete with the biggest chains on variety and price — without holding unsold inventory.",
    name: "Udaya Jewellers",
    location: "Kundapura, Karnataka",
  },
  {
    quote: "Thirty years in the trade, and this is the first partner that feels like an extension of our own team. Quality, turnaround and logistics — solved.",
    name: "Nanda Gold",
    location: "Udupi, Karnataka",
  },
];

export const SERVICES = [
  { key: "sourcing", title: "Sourcing & Procurement", blurb: "Direct access to a vetted network of Indian manufacturers — from Mumbai, Jaipur, Surat, Coimbatore and beyond.", steps: ["Tell us what you need", "We short-list verified makers", "You approve, we produce"] },
  { key: "recommendations", title: "Personalized Recommendations", blurb: "Curated design suggestions matched to your store's customer profile, regional taste and price band.", steps: ["Share your store profile", "We build a design brief", "Receive a private edit"] },
  { key: "logistics", title: "Logistics", blurb: "End-to-end shipping, customs, insurance and last-mile — handled, tracked, documented.", steps: ["Consolidated dispatch", "Customs & documentation", "Door-delivery with tracking"] },
  { key: "financing", title: "Financing", blurb: "Flexible payment terms so your working capital stays with you, not locked in inventory.", steps: ["Credit review", "Term sheet in 72 hrs", "Draw on demand"] },
  { key: "certification", title: "Quality Certification", blurb: "Every piece backed by BIS hallmarking and certification from industry-leading agencies.", steps: ["Assay at source", "Third-party certification", "Documentation bundle"] },
];

export const TIMELINE = [
  { year: "1980s", title: "Mattar Anand Kini & Sons founded", body: "A family group begins its legacy across Udupi, Mangalore, Shimoga and Davangere — manufacturing, printing, design, finance." },
  { year: "2000s", title: "45 years of industrial legacy", body: "The group compounds four decades of operational excellence across jewelry and allied industries." },
  { year: "2020", title: "Blue Velvet born", body: "A specialist B2B sourcing platform is spun up to solve the fragmented jewelry supply chain for independent retailers." },
  { year: "2023", title: "300+ retailers enabled", body: "From Karnataka to Delhi, independent jewelers begin competing with national chains on variety, quality and price." },
  { year: "2025", title: "Going global", body: "Singapore, Malaysia, UAE, UK and USA open up. Indian craftsmanship, sourced the modern way." },
];

export const TEAM = [
  { name: "Mattar Srinivas Kini", role: "Founder & CEO", bio: "Third-generation jeweler with 30+ years across manufacturing, retail and sourcing. Architect of Blue Velvet's platform vision.", img: "https://images.unsplash.com/photo-1656221010175-bcfeadcb6017?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBidXNpbmVzc21hbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc3ODA0MTU5MHww&ixlib=rb-4.1.0&q=85" },
  { name: "Anish Prabhu", role: "Director of Operations", bio: "Runs sourcing, logistics and quality at scale. Previously led supply chain for one of south India's largest jewelry brands.", img: "https://images.pexels.com/photos/7580763/pexels-photo-7580763.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

export const COUNTRIES = ["India", "Singapore", "Malaysia", "United Arab Emirates", "United Kingdom", "United States", "Australia", "Canada", "Hong Kong", "Thailand", "Indonesia", "Other"];

export const HERO_IMAGES = {
  aboutBanner: "https://images.unsplash.com/photo-1742137188729-d46186ac5733?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBqZXdlbHJ5JTIwZmxhdGxheSUyMGRhcmt8ZW58MHx8fHwxNzc4MDQxNTkwfDA&ixlib=rb-4.1.0&q=85",
  servicesBanner: "https://images.unsplash.com/photo-1761437856297-e7d0191f9a42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxnb2xkJTIwcmluZyUyMGJsYWNrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzgwNDE1OTB8MA&ixlib=rb-4.1.0&q=85",
  retailersBanner: "https://images.unsplash.com/photo-1677466890951-6723cfb98291?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBqZXdlbHJ5JTIwZmxhdGxheSUyMGRhcmt8ZW58MHx8fHwxNzc4MDQxNTkwfDA&ixlib=rb-4.1.0&q=85",
};

export const CATEGORIES = ["All", "Rings", "Pendants", "Earrings", "Necklaces"];
export const METALS = ["All", "22kt Gold", "18kt Gold", "Platinum", "Silver"];
